import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=46d6d0ec&scoped=true"
import script from "./Designers.vue?vue&type=script&lang=js"
export * from "./Designers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6d0ec",
  null
  
)

export default component.exports